import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useSearchParams } from 'react-router-dom';
import { PageBody, PageHero } from '../../../components/layout';
import { BusinessUnitsTab } from './BusinessUnitsTab';
import { PortfoliosTab } from './PortfoliosTab';
import { SectorsTab } from './SectorsTab';
const isTabKey = (s)=>s === 'sectors' || s === 'business-units' || s === 'portfolios';
const PANELS = {
    sectors: SectorsTab,
    'business-units': BusinessUnitsTab,
    portfolios: PortfoliosTab
};
export function OrgPage() {
    const [params, setParams] = useSearchParams();
    const active = isTabKey(params.get('tab')) ? params.get('tab') : 'sectors';
    const setActive = (next)=>{
        params.set('tab', next);
        setParams(params, {
            replace: true
        });
    };
    // Only the active panel mounts — the same lifecycle Radix TabsContent had.
    const ActivePanel = PANELS[active];
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": Testids.deliveryOrg.page,
            children: [
                /*#__PURE__*/ _jsx(PageHero, {
                    title: "Org Hierarchy",
                    subtitle: "Sectors, business units, and portfolios"
                }),
                /*#__PURE__*/ _jsx(SpecraTabBar, {
                    label: "Organization sections",
                    value: active,
                    onValueChange: setActive,
                    options: [
                        {
                            value: 'sectors',
                            label: 'Sectors',
                            testId: Testids.deliveryOrg.tabSectors
                        },
                        {
                            value: 'business-units',
                            label: 'Business Units',
                            testId: Testids.deliveryOrg.tabBusinessUnits
                        },
                        {
                            value: 'portfolios',
                            label: 'Portfolios',
                            testId: Testids.deliveryOrg.tabPortfolios
                        }
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ _jsx(ActivePanel, {})
                })
            ]
        })
    });
}
